// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Curry = require("rescript/lib/js/curry.js");
var React = require("react");
var Common = require("../utils/Common.bs.js");
var MM_parser = require("../mm-utils/MM_parser.bs.js");
var Belt_Array = require("rescript/lib/js/belt_Array.js");
var Caml_array = require("rescript/lib/js/caml_array.js");
var MM_context = require("../mm-utils/MM_context.bs.js");
var Belt_MapInt = require("rescript/lib/js/belt_MapInt.js");
var Belt_Option = require("rescript/lib/js/belt_Option.js");
var Caml_option = require("rescript/lib/js/caml_option.js");
var ColumnWidth = require("../ui-utils/ColumnWidth.bs.js");
var MM_wrk_editor = require("../worker/MM_wrk_editor.bs.js");
var ReactDOMStyle = require("@rescript/react/src/ReactDOMStyle.bs.js");
var Belt_MapString = require("rescript/lib/js/belt_MapString.js");
var MM_cmp_pe_stmt = require("./MM_cmp_pe_stmt.bs.js");
var MM_proof_table = require("../mm-utils/MM_proof_table.bs.js");
var MM_wrk_LoadCtx = require("../worker/MM_wrk_LoadCtx.bs.js");
var Belt_HashMapInt = require("rescript/lib/js/belt_HashMapInt.js");
var Belt_HashSetInt = require("rescript/lib/js/belt_HashSetInt.js");
var MM_parenCounter = require("../mm-utils/MM_parenCounter.bs.js");
var MM_react_common = require("../ui-utils/MM_react_common.bs.js");
var MM_substitution = require("../mm-utils/MM_substitution.bs.js");
var MM_wrk_ctx_data = require("../worker/MM_wrk_ctx_data.bs.js");
var MM_wrk_settings = require("../worker/MM_wrk_settings.bs.js");
var MM_cmp_user_stmt = require("../ui/MM_cmp_user_stmt.bs.js");
var MM_proof_verifier = require("../mm-utils/MM_proof_verifier.bs.js");
var Belt_HashMapString = require("rescript/lib/js/belt_HashMapString.js");
var Expln_React_Column = require("../../rescript-utils/main/react-mui-components/Expln_React_Column.bs.js");
var MM_cmp_jstf_to_svg = require("./MM_cmp_jstf_to_svg.bs.js");
var MM_wrk_pre_ctx_data = require("../worker/MM_wrk_pre_ctx_data.bs.js");
var Button = require("@mui/material/Button").default;
var MM_cmp_pe_frame_summary_state = require("./MM_cmp_pe_frame_summary_state.bs.js");

var $$location = window.location;

function createVDataRec(ctx, pRec, typeColors, exprsStr) {
  var match = pRec.proof;
  if (match.TAG === /* Hypothesis */0) {
    return ;
  }
  var args = match.args;
  var frame = MM_context.getFrameExn(ctx, match.label);
  var hypsStr = [];
  var eHyps = [];
  frame.hyps.forEach(function (hyp, i) {
        hypsStr.push(MM_context.frmIntsToSymsExn(ctx, frame, hyp.expr));
        if (hyp.typ === /* E */1) {
          eHyps.push(i);
          return ;
        }
        
      });
  var subs = Belt_HashMapString.make(frame.numOfVars);
  frame.hyps.forEach(function (hyp, i) {
        if (hyp.typ === /* F */0) {
          return Belt_HashMapString.set(subs, Caml_array.get(frame.frameVarToSymb, Caml_array.get(hyp.expr, 1)), Caml_array.get(exprsStr, Caml_array.get(args, i)).slice(1));
        }
        
      });
  var frmColors = Belt_HashMapString.make(frame.numOfVars);
  for(var i = 0 ,i_finish = frame.numOfVars; i < i_finish; ++i){
    var color = Belt_HashMapString.get(typeColors, MM_context.ctxIntToSymExn(ctx, Caml_array.get(frame.varTypes, i)));
    if (color !== undefined) {
      Belt_HashMapString.set(frmColors, Caml_array.get(frame.frameVarToSymb, i), color);
    }
    
  }
  return {
          hyps: hypsStr,
          eHyps: eHyps,
          asrt: MM_context.frmIntsToSymsExn(ctx, frame, frame.asrt),
          hypLabels: args,
          subs: subs,
          frmColors: frmColors
        };
}

function setProofTable(st, proofTable) {
  var frmCtx = st.frmCtx;
  var settings = st.settings;
  var typeColors = MM_wrk_settings.settingsGetTypeColors(settings);
  var exprsStr = proofTable.map(function (r) {
        return MM_context.ctxIntsToSymsExn(frmCtx, r.expr);
      });
  var vData = proofTable.map(function (pRec) {
        return createVDataRec(frmCtx, pRec, typeColors, exprsStr);
      });
  var essIdxs = Belt_HashSetInt.make(1000);
  var stepRenum = Belt_HashMapInt.make(1000);
  proofTable.forEach(function (pRec) {
        var match = pRec.proof;
        if (match.TAG === /* Hypothesis */0) {
          return ;
        }
        var args = match.args;
        var frame = MM_context.getFrameExn(frmCtx, match.label);
        frame.hyps.forEach(function (hyp, i) {
              if (hyp.typ === /* E */1) {
                return Belt_HashSetInt.add(essIdxs, Caml_array.get(args, i));
              }
              
            });
      });
  Belt_HashSetInt.add(essIdxs, proofTable.length - 1 | 0);
  proofTable.forEach(function (param, i) {
        if (Belt_HashSetInt.has(essIdxs, i)) {
          return Belt_HashMapInt.set(stepRenum, i, Belt_HashMapInt.size(stepRenum));
        }
        
      });
  return {
          settings: st.settings,
          frmCtx: st.frmCtx,
          frms: st.frms,
          parenCnt: st.parenCnt,
          syntaxTypes: st.syntaxTypes,
          frame: st.frame,
          disj: st.disj,
          hyps: st.hyps,
          asrt: st.asrt,
          proofTable: proofTable,
          symColors: st.symColors,
          vData: vData,
          showTypes: false,
          essIdxs: essIdxs,
          stepRenum: stepRenum,
          expandedIdxs: [],
          syntaxProofTableWasRequested: st.syntaxProofTableWasRequested,
          syntaxProofTableError: st.syntaxProofTableError
        };
}

function createInitialState(settings, preCtx, frmCtx, frame) {
  MM_context.moveConstsToBegin(frmCtx, settings.parens);
  var frms = MM_substitution.prepareFrmSubsData(frmCtx, undefined, undefined);
  var parenCnt = MM_parenCounter.parenCntMake(MM_wrk_ctx_data.prepareParenInts(frmCtx, settings.parens), true, undefined);
  var syntaxTypes = MM_wrk_pre_ctx_data.findSyntaxTypes(frmCtx, frms);
  var frmIntToCtxInt = function (i) {
    var n = MM_context.ctxSymToInt(frmCtx, i < 0 ? MM_context.ctxIntToSymExn(preCtx, i) : Caml_array.get(frame.frameVarToSymb, i));
    if (n !== undefined) {
      return n;
    }
    throw {
          RE_EXN_ID: MM_parser.MmException,
          _1: {
            msg: "ctx->ctxSymToInt == None in frmIntToCtxInt"
          },
          Error: new Error()
        };
  };
  var typeColors = MM_wrk_settings.settingsGetTypeColors(settings);
  var symColors = MM_wrk_editor.createSymbolColors(frmCtx, typeColors);
  var asrt = frame.asrt.map(frmIntToCtxInt);
  var disj = Belt_MapInt.size(frame.disj) > 0 ? MM_cmp_pe_frame_summary_state.createDisjGroups(frame.disj, (function (i) {
            var sym = MM_context.frmIntToSymExn(frmCtx, frame, i);
            return [
                    sym,
                    Belt_HashMapString.get(symColors, sym)
                  ];
          })) : undefined;
  var st_hyps = frame.hyps.map(function (hyp) {
        return {
                typ: hyp.typ,
                label: hyp.label,
                expr: hyp.expr.map(frmIntToCtxInt)
              };
      });
  var st_vData = [];
  var st_essIdxs = Belt_HashSetInt.make(0);
  var st_stepRenum = Belt_HashMapInt.make(0);
  var st_expandedIdxs = [];
  var st = {
    settings: settings,
    frmCtx: frmCtx,
    frms: frms,
    parenCnt: parenCnt,
    syntaxTypes: syntaxTypes,
    frame: frame,
    disj: disj,
    hyps: st_hyps,
    asrt: asrt,
    proofTable: undefined,
    symColors: symColors,
    vData: st_vData,
    showTypes: false,
    essIdxs: st_essIdxs,
    stepRenum: st_stepRenum,
    expandedIdxs: st_expandedIdxs,
    syntaxProofTableWasRequested: false,
    syntaxProofTableError: undefined
  };
  var proof = frame.proof;
  if (proof === undefined) {
    return st;
  }
  if (proof.TAG === /* Uncompressed */0) {
    var match = proof.labels;
    if (match.length === 1) {
      var match$1 = match[0];
      if (match$1 === "?") {
        return st;
      }
      
    }
    
  }
  var proofRoot = MM_proof_verifier.verifyProof(frmCtx, asrt, proof, (function (param, param$1) {
          return true;
        }));
  return setProofTable(st, MM_proof_table.createProofTableFromProof(proofRoot));
}

function setShowTypes(st, showTypes) {
  return {
          settings: st.settings,
          frmCtx: st.frmCtx,
          frms: st.frms,
          parenCnt: st.parenCnt,
          syntaxTypes: st.syntaxTypes,
          frame: st.frame,
          disj: st.disj,
          hyps: st.hyps,
          asrt: st.asrt,
          proofTable: st.proofTable,
          symColors: st.symColors,
          vData: st.vData,
          showTypes: showTypes,
          essIdxs: st.essIdxs,
          stepRenum: st.stepRenum,
          expandedIdxs: st.expandedIdxs,
          syntaxProofTableWasRequested: st.syntaxProofTableWasRequested,
          syntaxProofTableError: st.syntaxProofTableError
        };
}

function toggleShowTypes(st) {
  return setShowTypes(st, !st.showTypes);
}

function toggleIdxExpanded(st, idx) {
  if (st.expandedIdxs.includes(idx)) {
    return {
            settings: st.settings,
            frmCtx: st.frmCtx,
            frms: st.frms,
            parenCnt: st.parenCnt,
            syntaxTypes: st.syntaxTypes,
            frame: st.frame,
            disj: st.disj,
            hyps: st.hyps,
            asrt: st.asrt,
            proofTable: st.proofTable,
            symColors: st.symColors,
            vData: st.vData,
            showTypes: st.showTypes,
            essIdxs: st.essIdxs,
            stepRenum: st.stepRenum,
            expandedIdxs: st.expandedIdxs.filter(function (i) {
                  return i !== idx;
                }),
            syntaxProofTableWasRequested: st.syntaxProofTableWasRequested,
            syntaxProofTableError: st.syntaxProofTableError
          };
  } else {
    return {
            settings: st.settings,
            frmCtx: st.frmCtx,
            frms: st.frms,
            parenCnt: st.parenCnt,
            syntaxTypes: st.syntaxTypes,
            frame: st.frame,
            disj: st.disj,
            hyps: st.hyps,
            asrt: st.asrt,
            proofTable: st.proofTable,
            symColors: st.symColors,
            vData: st.vData,
            showTypes: st.showTypes,
            essIdxs: st.essIdxs,
            stepRenum: st.stepRenum,
            expandedIdxs: st.expandedIdxs.concat([idx]),
            syntaxProofTableWasRequested: st.syntaxProofTableWasRequested,
            syntaxProofTableError: st.syntaxProofTableError
          };
  }
}

function setSyntaxProofTableWasRequested(st, syntaxProofTableWasRequested) {
  return {
          settings: st.settings,
          frmCtx: st.frmCtx,
          frms: st.frms,
          parenCnt: st.parenCnt,
          syntaxTypes: st.syntaxTypes,
          frame: st.frame,
          disj: st.disj,
          hyps: st.hyps,
          asrt: st.asrt,
          proofTable: st.proofTable,
          symColors: st.symColors,
          vData: st.vData,
          showTypes: st.showTypes,
          essIdxs: st.essIdxs,
          stepRenum: st.stepRenum,
          expandedIdxs: st.expandedIdxs,
          syntaxProofTableWasRequested: syntaxProofTableWasRequested,
          syntaxProofTableError: st.syntaxProofTableError
        };
}

function setSyntaxProofTableError(st, syntaxProofTableError) {
  return {
          settings: st.settings,
          frmCtx: st.frmCtx,
          frms: st.frms,
          parenCnt: st.parenCnt,
          syntaxTypes: st.syntaxTypes,
          frame: st.frame,
          disj: st.disj,
          hyps: st.hyps,
          asrt: st.asrt,
          proofTable: st.proofTable,
          symColors: st.symColors,
          vData: st.vData,
          showTypes: st.showTypes,
          essIdxs: st.essIdxs,
          stepRenum: st.stepRenum,
          expandedIdxs: st.expandedIdxs,
          syntaxProofTableWasRequested: st.syntaxProofTableWasRequested,
          syntaxProofTableError: syntaxProofTableError
        };
}

function loadFrameContext(srcs, label, onProgress, onDone) {
  MM_wrk_LoadCtx.beginLoadingMmContext(MM_wrk_LoadCtx.createMmScopesForFrame(srcs, label), onProgress, onDone, undefined);
}

var dotPattern = /\./g;

function propsAreSame(a, b) {
  return a.top === b.top;
}

var make = React.memo((function (param) {
        var openFrameExplorer = param.openFrameExplorer;
        var label = param.label;
        var preCtxData = param.preCtxData;
        var modalRef = param.modalRef;
        var top = param.top;
        var match = React.useState(function () {
              return 0;
            });
        var setLoadPct = match[1];
        var match$1 = React.useState(function () {
              
            });
        var setLoadErr = match$1[1];
        var loadErr = match$1[0];
        var match$2 = React.useState(function () {
              
            });
        var setState = match$2[1];
        var state = match$2[0];
        var match$3 = React.useState(function () {
              return "100px";
            });
        var setStepWidth = match$3[1];
        var stepWidth = match$3[0];
        var match$4 = React.useState(function () {
              return "100px";
            });
        var setHypWidth = match$4[1];
        var hypWidth = match$4[0];
        var match$5 = React.useState(function () {
              return "100px";
            });
        var setRefWidth = match$5[1];
        var refWidth = match$5[0];
        React.useEffect((function () {
                Common.$$setTimeout((function (param) {
                        loadFrameContext(preCtxData.srcs, label, (function (pct) {
                                Curry._1(setLoadPct, (function (param) {
                                        return pct;
                                      }));
                              }), (function (res) {
                                if (res.TAG === /* Ok */0) {
                                  var frmCtx = res._0;
                                  return Curry._1(setState, (function (param) {
                                                return createInitialState(preCtxData.settingsV.val, preCtxData.ctxV.val, frmCtx, MM_context.getFrameExn(preCtxData.ctxV.val, label));
                                              }));
                                }
                                var msg = res._0;
                                Curry._1(setLoadErr, (function (param) {
                                        return msg;
                                      }));
                              }));
                      }), 10);
              }), []);
        var modifyState = function (update) {
          Curry._1(setState, (function (st) {
                  if (st !== undefined) {
                    return Curry._1(update, st);
                  }
                  
                }));
        };
        var syntaxProofTableWasRequested = Belt_Option.getWithDefault(Belt_Option.map(state, (function (st) {
                    return st.syntaxProofTableWasRequested;
                  })), false);
        React.useEffect((function () {
                if (syntaxProofTableWasRequested) {
                  Common.$$setTimeout((function (param) {
                          modifyState(function (__x) {
                                return setSyntaxProofTableWasRequested(__x, false);
                              });
                          modifyState(function (st) {
                                var ctx = st.frmCtx;
                                var msg = MM_cmp_user_stmt.textToSyntaxProofTable(ctx, st.asrt.map(function (i) {
                                          return {
                                                  sym: MM_context.ctxIntToSymExn(ctx, i),
                                                  color: undefined
                                                };
                                        }), st.syntaxTypes, st.frms, st.parenCnt, MM_cmp_user_stmt.getLastSyntaxType(undefined), MM_cmp_user_stmt.setLastSyntaxType);
                                if (msg.TAG !== /* Ok */0) {
                                  return setSyntaxProofTableError(st, msg._0);
                                }
                                var st$1 = setProofTable(st, msg._0);
                                return setShowTypes(st$1, true);
                              });
                        }), 10);
                }
                
              }), [syntaxProofTableWasRequested]);
        var getStepNum = function (state, pRecIdx) {
          if (state.showTypes) {
            return pRecIdx + 1 | 0;
          } else {
            return Belt_Option.getWithDefault(Belt_Option.map(Belt_HashMapInt.get(state.stepRenum, pRecIdx), (function (n) {
                              return n + 1 | 0;
                            })), 0);
          }
        };
        var getNumberOfRowsInProofTable = function (state) {
          if (state === undefined) {
            return 0;
          }
          var proofTable = state.proofTable;
          if (proofTable !== undefined) {
            if (state.showTypes) {
              return proofTable.length;
            } else {
              return proofTable.reduce((function (cnt, param, idx) {
                            return cnt + (
                                    Belt_HashSetInt.has(state.essIdxs, idx) ? 1 : 0
                                  ) | 0;
                          }), 0);
            }
          } else {
            return 0;
          }
        };
        var numberOfRowsInProofTable = getNumberOfRowsInProofTable(state);
        var proofTableId = "tbl-" + label + "";
        var classColStep = "step";
        var classColHyp = "hyp";
        var classColRef = "ref";
        React.useEffect((function () {
                var proofTableIdCssSelector = proofTableId.replace(dotPattern, "\\.");
                Curry._1(setStepWidth, (function (param) {
                        return String(ColumnWidth.calcColumnWidth("#" + proofTableIdCssSelector + " ." + classColStep + "", 30, 1000)) + "px";
                      }));
                Curry._1(setHypWidth, (function (param) {
                        return String(ColumnWidth.calcColumnWidth("#" + proofTableIdCssSelector + " ." + classColHyp + "", 30, 100) + 5 | 0) + "px";
                      }));
                Curry._1(setRefWidth, (function (param) {
                        return String(ColumnWidth.calcColumnWidth("#" + proofTableIdCssSelector + " ." + classColRef + "", 30, 1000)) + "px";
                      }));
              }), [numberOfRowsInProofTable]);
        var rndLabel = function (state) {
          var asrtType = state.frame.isAxiom ? React.createElement("span", {
                  style: {
                    color: "red"
                  }
                }, "Axiom") : React.createElement("span", {
                  style: {
                    color: "green"
                  }
                }, "Theorem");
          return React.createElement("span", undefined, asrtType, React.createElement("span", {
                          style: {
                            cursor: "pointer",
                            fontWeight: "bold"
                          }
                        }, " " + state.frame.label), React.createElement("span", {
                          style: {
                            color: "grey",
                            fontFamily: "Arial Narrow",
                            fontSize: "x-small",
                            marginLeft: "5px"
                          }
                        }, " " + String(Belt_MapString.size(state.frms) + 1 | 0)));
        };
        var rndSummary = function (state) {
          var style = {
            borderCollapse: "collapse"
          };
          return React.createElement("table", {
                      style: style
                    }, React.createElement("tbody", undefined, state.hyps.filter(function (hyp) {
                                return hyp.typ === /* E */1;
                              }).map(function (hyp, i) {
                              return React.createElement("tr", {
                                          key: String(i)
                                        }, React.createElement("td", {
                                              style: Object.assign({}, style, {
                                                    paddingLeft: "15px"
                                                  })
                                            }, Common.circleChar + Common.nbsp + hyp.label), React.createElement("td", {
                                              style: Object.assign({}, style, {
                                                    paddingLeft: "10px"
                                                  })
                                            }, React.createElement(MM_cmp_pe_stmt.make, {
                                                  modalRef: modalRef,
                                                  ctx: state.frmCtx,
                                                  syntaxTypes: state.syntaxTypes,
                                                  frms: state.frms,
                                                  parenCnt: state.parenCnt,
                                                  stmt: hyp.expr,
                                                  symColors: state.symColors,
                                                  symRename: undefined,
                                                  editStmtsByLeftClick: preCtxData.settingsV.val.editStmtsByLeftClick
                                                })));
                            }), React.createElement("tr", undefined, React.createElement("td", {
                                  style: {
                                    paddingTop: "10px",
                                    verticalAlign: "top"
                                  }
                                }, state.frame.label), React.createElement("td", {
                                  style: Object.assign({}, style, {
                                        paddingTop: "10px",
                                        paddingLeft: "10px",
                                        verticalAlign: "top"
                                      })
                                }, React.createElement(MM_cmp_pe_stmt.make, {
                                      modalRef: modalRef,
                                      ctx: state.frmCtx,
                                      syntaxTypes: state.syntaxTypes,
                                      frms: state.frms,
                                      parenCnt: state.parenCnt,
                                      stmt: state.asrt,
                                      symColors: state.symColors,
                                      symRename: undefined,
                                      editStmtsByLeftClick: preCtxData.settingsV.val.editStmtsByLeftClick
                                    })))));
        };
        var rndDescr = function (state) {
          return React.createElement("span", undefined, Belt_Option.getWithDefault(state.frame.descr, "This " + (
                          state.frame.isAxiom ? "axiom" : "theorem"
                        ) + " doesn't have any description."));
        };
        var rndDisj = function (state) {
          var disj = state.disj;
          if (disj !== undefined) {
            return React.createElement("div", undefined, "Distinct variable groups:" + MM_cmp_pe_frame_summary_state.disjGrpDelim, MM_cmp_pe_frame_summary_state.rndDisj(disj));
          } else {
            return React.createElement("div", {
                        style: {
                          display: "none"
                        }
                      });
          }
        };
        var rndHyp = function (state, pRec) {
          var match = pRec.proof;
          if (match.TAG === /* Hypothesis */0) {
            return null;
          }
          var args = match.args;
          var elems = [];
          for(var i = 0 ,i_finish = args.length; i < i_finish; ++i){
            var argIdx = Caml_array.get(args, i);
            if (state.showTypes || Belt_HashSetInt.has(state.essIdxs, argIdx)) {
              var iStr = String(i);
              if (elems.length > 0) {
                elems.push(React.createElement("span", {
                          key: "delim-" + iStr
                        }, ", "));
              }
              elems.push(React.createElement("a", {
                        key: "hyp-" + iStr,
                        href: "#" + proofTableId + "-" + String(argIdx)
                      }, String(getStepNum(state, argIdx))));
            }
            
          }
          return elems;
        };
        var linkStyle = {
          color: "rgb(0,0,238)",
          cursor: "pointer",
          textDecoration: "underline",
          textDecorationColor: "rgb(0,0,238)"
        };
        var rndRef = function (pRec) {
          var match = pRec.proof;
          if (match.TAG === /* Hypothesis */0) {
            return match.label;
          }
          var label = match.label;
          return React.createElement("span", {
                      style: linkStyle,
                      onClick: (function (param) {
                          return MM_react_common.clickHnd(undefined, undefined, undefined, undefined, (function (param) {
                                        Curry._1(openFrameExplorer, label);
                                      }), undefined, param);
                        })
                    }, label);
        };
        var expBtnBaseStyle = {
          border: "1px solid",
          color: "lightgrey",
          cursor: "pointer",
          fontFamily: "courier",
          fontSize: "10px",
          marginRight: "3px",
          padding: "1px 3px 0px 2px"
        };
        var rndExpBtn = function (state, pRecIdx) {
          var match = Caml_array.get(state.vData, pRecIdx);
          var style = match !== undefined ? expBtnBaseStyle : Object.assign({}, expBtnBaseStyle, {
                  opacity: "0"
                });
          return React.createElement("a", {
                      style: style,
                      onClick: (function (param) {
                          modifyState(function (__x) {
                                return toggleIdxExpanded(__x, pRecIdx);
                              });
                        })
                    }, state.expandedIdxs.includes(pRecIdx) ? "-" : "+");
        };
        var rndExprText = function (state, pRec) {
          return React.createElement(MM_cmp_pe_stmt.make, {
                      modalRef: modalRef,
                      ctx: state.frmCtx,
                      syntaxTypes: state.syntaxTypes,
                      frms: state.frms,
                      parenCnt: state.parenCnt,
                      stmt: pRec.expr,
                      symColors: state.symColors,
                      symRename: undefined,
                      editStmtsByLeftClick: preCtxData.settingsV.val.editStmtsByLeftClick
                    });
        };
        var rndExprSvg = function (state, vDataRec) {
          var labelIdxs = state.showTypes ? vDataRec.hypLabels : vDataRec.eHyps.map(function (i) {
                  return Caml_array.get(vDataRec.hypLabels, i);
                });
          return React.createElement(MM_cmp_jstf_to_svg.make, {
                      hyps: state.showTypes ? vDataRec.hyps : vDataRec.eHyps.map(function (i) {
                              return Caml_array.get(vDataRec.hyps, i);
                            }),
                      hypLabels: labelIdxs.map(function (i) {
                            return String(getStepNum(state, i));
                          }),
                      asrt: vDataRec.asrt,
                      subs: vDataRec.subs,
                      frmColors: Caml_option.some(vDataRec.frmColors),
                      ctxColors1: Caml_option.some(state.symColors),
                      onLabelClick: (function (i, param) {
                          $$location.hash = "#" + proofTableId + "-" + String(Caml_array.get(labelIdxs, i));
                        })
                    });
        };
        var rndExpr = function (state, pRec, pRecIdx) {
          var vDataRec = Caml_array.get(state.vData, pRecIdx);
          return React.createElement("table", undefined, React.createElement("tbody", undefined, React.createElement("tr", undefined, React.createElement("td", {
                                  style: {
                                    verticalAlign: "top"
                                  }
                                }, rndExpBtn(state, pRecIdx)), React.createElement("td", {
                                  style: {
                                    verticalAlign: "top"
                                  }
                                }, vDataRec !== undefined && state.expandedIdxs.includes(pRecIdx) ? rndExprSvg(state, vDataRec) : rndExprText(state, pRec)))));
        };
        var rndProof = function (state) {
          var tdStyle = {
            border: "1px solid black",
            borderCollapse: "collapse",
            padding: "5px",
            verticalAlign: "verticalAlign"
          };
          var rowStyle = ReactDOMStyle.unsafeAddProp({}, "scrollMarginTop", String(top) + "px");
          var proofTable = state.proofTable;
          if (proofTable !== undefined) {
            return React.createElement(Expln_React_Column.make, {
                        spacing: 0,
                        children: Caml_option.some(null)
                      }, state.frame.isAxiom ? React.createElement("span", {
                              style: {
                                fontWeight: "bold"
                              }
                            }, "Syntax breakdown") : React.createElement(Button, {
                              onClick: (function (param) {
                                  modifyState(toggleShowTypes);
                                }),
                              children: Caml_option.some(state.showTypes ? "Hide types" : "Show types")
                            }), React.createElement("table", {
                            id: proofTableId,
                            style: Object.assign({}, tdStyle, {
                                  tableLayout: "fixed",
                                  width: "100%"
                                })
                          }, React.createElement("thead", undefined, React.createElement("tr", undefined, React.createElement("th", {
                                        style: Object.assign({}, tdStyle, {
                                              width: stepWidth
                                            })
                                      }, "Step"), React.createElement("th", {
                                        style: Object.assign({}, tdStyle, {
                                              width: hypWidth
                                            })
                                      }, "Hyp"), React.createElement("th", {
                                        style: Object.assign({}, tdStyle, {
                                              width: refWidth
                                            })
                                      }, "Ref"), React.createElement("th", {
                                        style: tdStyle
                                      }, "Expression"))), React.createElement("tbody", undefined, proofTable.map(function (pRec, idx) {
                                        return [
                                                pRec,
                                                idx
                                              ];
                                      }).filter(function (param) {
                                      if (state.showTypes) {
                                        return true;
                                      } else {
                                        return Belt_HashSetInt.has(state.essIdxs, param[1]);
                                      }
                                    }).map(function (param) {
                                    var idx = param[1];
                                    var pRec = param[0];
                                    return React.createElement("tr", {
                                                key: String(idx),
                                                id: proofTableId + "-" + String(idx),
                                                style: rowStyle
                                              }, React.createElement("td", {
                                                    className: classColStep,
                                                    style: Object.assign({}, tdStyle, {
                                                          verticalAlign: "top",
                                                          width: stepWidth
                                                        })
                                                  }, String(getStepNum(state, idx))), React.createElement("td", {
                                                    className: classColHyp,
                                                    style: Object.assign({}, tdStyle, {
                                                          verticalAlign: "top",
                                                          width: hypWidth
                                                        })
                                                  }, rndHyp(state, pRec)), React.createElement("td", {
                                                    className: classColRef,
                                                    style: Object.assign({}, tdStyle, {
                                                          verticalAlign: "top",
                                                          width: refWidth
                                                        })
                                                  }, rndRef(pRec)), React.createElement("td", {
                                                    style: tdStyle
                                                  }, rndExpr(state, pRec, idx)));
                                  }))));
          }
          if (!state.frame.isAxiom) {
            return "This assertion doesn't have a proof.";
          }
          if (state.syntaxProofTableWasRequested) {
            return "Building a syntax breakdown...";
          }
          var msg = state.syntaxProofTableError;
          if (msg !== undefined) {
            return React.createElement("pre", {
                        style: {
                          color: "red"
                        }
                      }, "Could not build a syntax breakdown: " + msg + "");
          } else {
            return React.createElement(Button, {
                        onClick: (function (param) {
                            modifyState(function (__x) {
                                  return setSyntaxProofTableWasRequested(__x, true);
                                });
                          }),
                        children: "Show syntax breakdown"
                      });
          }
        };
        var rndFooter = function (param) {
          return Belt_Array.range(1, 12).map(function (i) {
                      return React.createElement("span", {
                                  key: String(i),
                                  style: {
                                    fontSize: "20px"
                                  }
                                }, Common.nbsp);
                    });
        };
        if (state !== undefined) {
          return React.createElement(Expln_React_Column.make, {
                      spacing: 3,
                      style: {
                        padding: "5px 10px"
                      },
                      children: Caml_option.some(null)
                    }, rndLabel(state), rndDescr(state), rndDisj(state), rndSummary(state), rndProof(state), rndFooter(undefined));
        } else if (loadErr !== undefined) {
          return "Error: " + loadErr + "";
        } else {
          return "Loading " + Common.floatToPctStr(match[0]) + "";
        }
      }), propsAreSame);

exports.$$location = $$location;
exports.createVDataRec = createVDataRec;
exports.setProofTable = setProofTable;
exports.createInitialState = createInitialState;
exports.setShowTypes = setShowTypes;
exports.toggleShowTypes = toggleShowTypes;
exports.toggleIdxExpanded = toggleIdxExpanded;
exports.setSyntaxProofTableWasRequested = setSyntaxProofTableWasRequested;
exports.setSyntaxProofTableError = setSyntaxProofTableError;
exports.loadFrameContext = loadFrameContext;
exports.dotPattern = dotPattern;
exports.propsAreSame = propsAreSame;
exports.make = make;
/* location Not a pure module */
